/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_USER_PROFILE = '[Account] Get User Profile',
  GET_USER_PROFILE_SUCCESS = '[Account] Get User Profile Success',
  GET_USER_PROFILE_FAILED = '[Account] Get User Profile Failed',

  GET_PLAYERS = '[Account] Get Players',
  GET_PLAYERS_SUCCESS = '[Account] Get Players Success',

  GET_STUDENT_APPLICATION = '[Account] Get Student Application',
  GET_STUDENT_APPLICATION_SUCCESS = '[Account] Get Student Application Success',
  GET_STUDENT_APPLICATION_FAILED = '[Account] Get Student Application Failed',

  GET_PRE_ENROLLMENT_REQUIREMENTS = '[Account] Get Pre Enrollment Requirements',
  GET_PRE_ENROLLMENT_REQUIREMENTS_SUCCESS = '[Account] Get Pre Enrollment Requirements Success',
  GET_PRE_ENROLLMENT_REQUIREMENTS_FAILED = '[Account] Get Pre Enrollment Requirements Failed',

  GET_ACADEMIC_REQUIREMENTS = '[Account] Get Academic Requirements',
  GET_ACADEMIC_REQUIREMENTS_SUCCESS = '[Account] Get Academic Requirements Success',
  GET_ACADEMIC_REQUIREMENTS_FAILED = '[Account] Get Academic Requirements Failed',

  RESERVE_ENROLLMENT = '[Account] Reserve Enrollment',
  RESERVE_ENROLLMENT_SUCCESS = '[Account] Reserve Enrollment Success',
  RESERVE_ENROLLMENT_FAILED = '[Account] Reserve Enrollment Failed',

  SUBMIT_PRE_ENLISTMENT = '[Account] Submit Pre Enlistment',
  SUBMIT_PRE_ENLISTMENT_SUCCESS = '[Account] Submit Pre Enlistment Success',
  SUBMIT_PRE_ENLISTMENT_FAILED = '[Account] Submit Pre Enlistment Failed',

  GET_LATEST_ENROLLMENT_STATUS = '[Account] Get Latest Enrollment Status',
  GET_LATEST_ENROLLMENT_STATUS_SUCCESS = '[Account] Get Latest Enrollment Status Success',
  GET_LATEST_ENROLLMENT_STATUS_FAILED = '[Account] Get Latest Enrollment Status Failed',

  GET_CURRICULUM_COMPLETION = '[Account] Get Curriculum Completion',
  GET_CURRICULUM_COMPLETION_SUCCESS = '[Account] Get Curriculum Completion Success',
  GET_CURRICULUM_COMPLETION_FAILED = '[Account] Get Curriculum Completion Failed',
}

export const getPlayers = createAction(
  ActionTypes.GET_PLAYERS
);

export const getPlayersSuccess = createAction(
	ActionTypes.GET_PLAYERS_SUCCESS,
  props<{ data: any }>()
);

export const getUserProfile = createAction(
  ActionTypes.GET_USER_PROFILE
);


export const getUserProfileSuccess = createAction(
  ActionTypes.GET_USER_PROFILE_SUCCESS,
  props<{ data: any }>()
);

export const getUserProfileFailed = createAction(
	ActionTypes.GET_USER_PROFILE_FAILED,
  props<{ data: any }>()
);

export const getStudentApplication = createAction(
  ActionTypes.GET_STUDENT_APPLICATION,
  props<{ redirect: Boolean }>()
);

export const getStudentApplicationSuccess = createAction(
	ActionTypes.GET_STUDENT_APPLICATION_SUCCESS,
  props<{ data: any, redirect: Boolean }>()
);

export const getStudentApplicationFailed = createAction(
  ActionTypes.GET_STUDENT_APPLICATION_FAILED,
  props<{ data: any }>()
);

export const getPreEnrollmentRequirements = createAction(
  ActionTypes.GET_PRE_ENROLLMENT_REQUIREMENTS
);

export const getPreEnrollmentRequirementsSuccess = createAction(
	ActionTypes.GET_PRE_ENROLLMENT_REQUIREMENTS_SUCCESS,
  props<{ data: any }>()
);

export const getPreEnrollmentRequirementsFailed = createAction(
  ActionTypes.GET_PRE_ENROLLMENT_REQUIREMENTS_FAILED,
  props<{ data: any }>()
);

export const getAcademicRequirements = createAction(
  ActionTypes.GET_ACADEMIC_REQUIREMENTS,
  props<{ data: any }>()
);

export const getAcademicRequirementsSuccess = createAction(
	ActionTypes.GET_ACADEMIC_REQUIREMENTS_SUCCESS,
  props<{ data: any }>()
);

export const getAcademicRequirementsFailed = createAction(
  ActionTypes.GET_ACADEMIC_REQUIREMENTS_FAILED,
  props<{ data: any }>()
);

export const reserveEnrollment = createAction(
  ActionTypes.RESERVE_ENROLLMENT
);

export const reserveEnrollmentSuccess = createAction(
	ActionTypes.RESERVE_ENROLLMENT_SUCCESS,
  props<{ data: any }>()
);

export const reserveEnrollmentFailed = createAction(
  ActionTypes.RESERVE_ENROLLMENT_FAILED,
  props<{ data: any }>()
);

export const submitPreEnlistment = createAction(
  ActionTypes.SUBMIT_PRE_ENLISTMENT,
  props<{ data: any }>()
);

export const submitPreEnlistmentSuccess = createAction(
	ActionTypes.SUBMIT_PRE_ENLISTMENT_SUCCESS,
  props<{ data: any }>()
);

export const submitPreEnlistmentFailed = createAction(
  ActionTypes.SUBMIT_PRE_ENLISTMENT_FAILED,
  props<{ data: any }>()
);

export const getLatestEnrollmentStatus = createAction(
  ActionTypes.GET_LATEST_ENROLLMENT_STATUS
);

export const getLatestEnrollmentStatusSuccess = createAction(
	ActionTypes.GET_LATEST_ENROLLMENT_STATUS_SUCCESS,
  props<{ data: any }>()
);

export const getLatestEnrollmentStatusFailed = createAction(
  ActionTypes.GET_LATEST_ENROLLMENT_STATUS_FAILED,
  props<{ data: any }>()
);

export const getCurriculumCompletion = createAction(
  ActionTypes.GET_CURRICULUM_COMPLETION,
  props<{ data: any }>()
);

export const getCurriculumCompletionSuccess = createAction(
	ActionTypes.GET_CURRICULUM_COMPLETION_SUCCESS,
  props<{ data: any }>()
);

export const getCurriculumCompletionFailed = createAction(
  ActionTypes.GET_CURRICULUM_COMPLETION_FAILED,
  props<{ data: any }>()
);